"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolkadotSS58Format = void 0;
/**
 * Prefix for ss58-encoded addresses on Polkadot, Kusama, and Westend. Note:
 * 42, the Westend prefix, is also the default for Substrate-based chains.
 */
var PolkadotSS58Format;
(function (PolkadotSS58Format) {
    PolkadotSS58Format[PolkadotSS58Format["polkadot"] = 0] = "polkadot";
    PolkadotSS58Format[PolkadotSS58Format["kusama"] = 2] = "kusama";
    PolkadotSS58Format[PolkadotSS58Format["westend"] = 42] = "westend";
    PolkadotSS58Format[PolkadotSS58Format["substrate"] = 42] = "substrate";
})(PolkadotSS58Format = exports.PolkadotSS58Format || (exports.PolkadotSS58Format = {}));
//# sourceMappingURL=polkadotss58Format.js.map